<template>
  <div style="width:256px;display:flex">
    <img :src="themeLogo || require('@/assets/images/logo.png')" class="logo">
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { getSetting } from '@/utils/auth'

export default {
  name: 'Logo',
  data() {
    return {
      themeLogo: ''
    }
  },
  computed: {
    ...mapGetters(['logo'])
  },
  watch: {
    logo: {
      handler(val) {
        // 存于storage里的个性化
        let sessionLogo = getSetting() ? getSetting().bannerLogo : ''
        this.themeLogo = val ? val : (sessionLogo ? sessionLogo : '')
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
  .logo {
    width: 224px;
    height: 32px;
    margin: 11px 12px;
    float: left;
  }
</style>
